<script>

export default {
  name: "t-form-wrapped",
  props: {
    status: {
      type: String,
      default: ""
    },
    command: String,
  },
  data() {
    return {}
  },

  render(h) {

    function deepClone(vnodes, createElement, status, command) {

      function cloneVNode(vnode) {

        if (vnode.componentOptions && vnode.componentOptions.children) {

          const clonedChildren = vnode.componentOptions.children && vnode.componentOptions.children
              .map(vnode => cloneVNode(vnode));

          const cloned = createElement(vnode.tag, vnode.data, clonedChildren);

          cloned.text = vnode.text
          cloned.children = null
          cloned.isComment = vnode.isComment
          cloned.componentInstance = vnode.componentInstance
          cloned.componentOptions = vnode.componentOptions
          cloned.componentOptions.children = clonedChildren
          cloned.elm = vnode.elm
          cloned.context = vnode.context
          cloned.ns = vnode.ns
          cloned.isStatic = vnode.isStatic
          cloned.key = vnode.key
          cloned.fixed = true

          return cloned


        } else {

          const clonedChildren = vnode.children && vnode.children
              .map(vnode => cloneVNode(vnode));

          const cloned = createElement(vnode.tag, vnode.data, clonedChildren);

          cloned.text = vnode.text
          cloned.isComment = vnode.isComment
          cloned.componentInstance = vnode.componentInstance
          cloned.componentOptions = vnode.componentOptions
          cloned.elm = vnode.elm
          cloned.context = vnode.context
          cloned.ns = vnode.ns
          cloned.isStatic = vnode.isStatic
          cloned.key = vnode.key


          if (cloned.tag) {

            if (cloned.tag.indexOf("t-input") > -1 && cloned.componentOptions && cloned.componentOptions.propsData) {
              cloned.componentOptions.propsData.formStatus = status
              cloned.componentOptions.propsData.formCommand = command

            }

          }

          return cloned;

        }


      }

      const clonedVNodes = vnodes.map(vnode => cloneVNode(vnode))
      return clonedVNodes;
    }

    return h('div', {}, [
      h('div', {}, [...deepClone(this.$slots.default, h, this.status, this.command)])
    ])

  }

}
</script>
